import { Box, Typography } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import * as React from "react";

export default function LinearBuffer() {
	const [progress, setProgress] = React.useState(0);
	const [buffer, setBuffer] = React.useState(10);

	const progressRef = React.useRef(() => {});
	React.useEffect(() => {
		progressRef.current = () => {
			if (progress > 100) {
				setProgress(0);
				setBuffer(10);
			} else {
				const diff = Math.random() * 10;
				const diff2 = Math.random() * 10;
				setProgress(progress + diff);
				setBuffer(progress + diff + diff2);
			}
		};
	});

	React.useEffect(() => {
		const timer = setInterval(() => {
			progressRef.current();
		}, 500);

		return () => {
			clearInterval(timer);
		};
	}, []);

	return (
		<Box
			sx={{
				width: "99vw",
				height: "99vh",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					maxWidth: "40vw",
					alignItems: "center",
					justifyContent: "center",
					margin: "auto",
				}}
			>
				<Typography>
					Fetching App Data
					<LinearProgress
						sx={{ mt: 2 }}
						variant="buffer"
						value={progress}
						valueBuffer={buffer}
					/>
				</Typography>
			</Box>
		</Box>
	);
}
